import type { IImpressionWidget } from '@schibsted/pulse-sdk';
import type { PulseContextInputParams } from '../../../types/index.js';

export interface WidgetViewAttributes {
  'data-track-event': string;
  'data-track-object-type': 'Widget';
}

export const buildImpressionWidgetAttributes = (
  event: PulseContextInputParams<IImpressionWidget>,
): WidgetViewAttributes => ({
  'data-track-event': JSON.stringify(event),
  'data-track-object-type': 'Widget',
});
